import type { FaireProductEntity } from "../../entity_types/product";

export const p_24r8kftcyq: FaireProductEntity = {
  token: "p_24r8kftcyq",
  type: "product",
  name: "Pink Floyd Adult Socks - Classic Music Band Gift Size 10-13",
  brandToken: "b_q667fpxnjn",
  brandName: "Square Deal Recordings & Supplies",
  imageUrl:
    "https://cdn.faire.com/fastly/afccef6375ef3bd5a4f55af02b2b4732d671ad2dbb25a6d40d69d09d9749cf98.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c896ea842c8ad97f97fe6ccd15a88a3ddec303745d2a531acebdb4ef561ceb56.jpeg",
    "https://cdn.faire.com/fastly/ee6a9588962f5c8aba95912a14a18b80d62747552f48cc31b15cdb5459431854.jpeg",
    "https://cdn.faire.com/fastly/d30f747e8e227dcf598f1f98894a3d21e72de2be1b500b6457e975a3e229338d.jpeg",
  ],
  priceDollars: 3,
  description:
    "These Pink Floyd socks have the following dimensions:\n• leg: 22 cm (8.6 inches);\n• foot: 20 cm (7.87 inches);\n• width 8.5 cm (3.34 inches);\n• sock size: 10 - 13.\nMSRP: $8.99/pair",
  tags: [],
  msrpDollars: 8.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-05T00:27:33.155Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
